import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'

export const LegendItem = ({
  className,
  color,
  label,
}: {
  className?: string
  color: string
  label: string
}) => {
  return (
    <div className='flex items-center'>
      <div
        className='mr-2 h-3/4 rounded-sm p-2'
        style={{ backgroundColor: color }}
      />
      <Text
        className={classMerge('text-neutral600', className)}
        styleName='p-small'
        value={label}
      />
    </div>
  )
}
